import { motion } from "framer-motion";
import { ArrowUpRight, Sparkles, ScrollText, MessageCircleHeart, NotebookPen } from "lucide-react";
import { MEVSME } from "../data";

const STEP_ICONS = [ScrollText, MessageCircleHeart, NotebookPen];

export default function MeVsMe() {
  return (
    <section id="mevsme" data-testid="mevsme-section" className="relative py-24 md:py-32 px-6 md:px-12 lg:px-20">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Left — content */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-7"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#D4AF37]" />
            <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#D4AF37]">The App · Personal Growth</span>
          </div>

          <h2 className="font-display text-4xl md:text-5xl font-black uppercase tracking-tight leading-[0.95]">
            Me vs Me — <span className="gold-text">Become the Next Version of You</span>
          </h2>

          <p className="mt-6 text-lg text-[#A3A8B8] leading-relaxed max-w-2xl">{MEVSME.intro}</p>

          <div className="mt-8 grid sm:grid-cols-2 gap-px bg-[#1D2847] border border-[#1D2847]">
            {MEVSME.pillars.map((p) => (
              <div key={p.title} className="bg-[#0C142A] p-5">
                <h4 className="font-display font-bold text-lg text-[#F8F9FA]">{p.title}</h4>
                <p className="text-sm text-[#A3A8B8] mt-1">{p.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 space-y-3">
            {MEVSME.steps.map((s, i) => {
              const Icon = STEP_ICONS[i];
              return (
                <div key={s} className="flex items-start gap-3">
                  <span className="p-2 border border-[#D4AF37]/40 text-[#D4AF37] shrink-0"><Icon size={16} /></span>
                  <span className="text-[#C9CDD9]">{s}</span>
                </div>
              );
            })}
          </div>

          <a
            href={MEVSME.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mevsme-cta"
            className="mt-10 inline-flex items-center gap-2 bg-[#D4AF37] text-[#050A15] hover:bg-[#F0C84B] font-bold uppercase tracking-wider px-8 py-4 transition-colors"
          >
            Begin Your Journey <ArrowUpRight size={18} />
          </a>
          <span className="ml-4 text-sm text-[#A3A8B8]">mevsmes.com</span>
        </motion.div>

        {/* Right — visual */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="lg:col-span-5"
        >
          <div className="relative">
            <img src={MEVSME.image} alt="Me vs Me" className="w-full h-[460px] object-cover border border-[#1D2847]" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050A15] via-[#050A15]/30 to-transparent" />
            <div className="absolute bottom-0 inset-x-0 p-7">
              <div className="flex items-center gap-2 text-[#D4AF37] text-xs uppercase tracking-wider font-bold mb-3">
                <Sparkles size={14} /> Today's Whisper
              </div>
              <p className="font-display text-xl text-[#F8F9FA] italic leading-snug">“{MEVSME.whisper}”</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
